/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import {
  Injectable
} from '@angular/core';
import {
  environment
} from '../../../environments/environment';
import {
  HttpClient,
} from '@angular/common/http';
// import { BSessionStorage } from '../service/bSessionStorage.service';
import 'rxjs/add/operator/toPromise';
import { SystemService } from '../../service/system.service';
import { BSessionStorage } from '../../service/bSessionStorage.service';
import { BLocalStorageService } from '../../service/bLocalStorage.service';
import { BAppService } from '../../service/bApp.service';
import { PubSubService } from '../../service/pubSub.service';

@Injectable()
export class dashboardService {

  private dashboardObj: any = {};
  private url = '';
  private bSessionStorage;
  private bLocalStorage;
  private uuid = '';
  private fbregid = '';

  constructor(private http: HttpClient, private bAppService: BAppService, private pubSub: PubSubService) {
    let systemService = new SystemService();
    this.bSessionStorage = new BSessionStorage();
    this.bLocalStorage = new BLocalStorageService();
    this.uuid = this.bLocalStorage.getValue('uuid');
    this.fbregid = this.bLocalStorage.getValue('registrationId');
    if (environment && environment.properties) {
      this.url = systemService.getAppUrl();
    }
  }

  get dashboardObject() {
    if (this.dashboardObj) 
    return this.dashboardObj;
    // return {};
  }

  set dashboardObject(dashboardObj) {
    if (dashboardObj) this.dashboardObj = dashboardObj;
  }

  // getDashboards() {
  //   const url = `${this.url}notification/getDashboards`;
  //   return this.http.post(url, null).subscribe(result => console.log(result));
  // }
  getDashboards() {
    const url = `${this.url}notification/getDashboards`;
    return this.http.post(url, null)
      .toPromise()
      .then(response => {
        if (response) {
          this.dashboardObj = response;
        }
        return this.dashboardObj;
      })
      .catch(reason => {
        console.error(reason);
        // return reason;
      })
  }

  updateDashboards(dashboard) {
    const url = `${this.url}notification/updateDashboards`;
    let userObj = this.bSessionStorage.getValue('userObj');
    let userAccountObj = {
      "uuid": this.uuid,
      "fbregid": this.fbregid,
      "bUserAccount": userObj
    }
    let sendObj = {
      dashboard: dashboard,
      userAccountObj
    }
    this.dashboardObj = { dashboard: dashboard };
    return this.http.post(url,
      sendObj
    )
      .toPromise()
      .then(response => {
        // this.dashboardObject = dashboard;
        this.pubSub.$pub('dashBoadrd', response);
        this.bAppService.openSnackBar("Dashboards saved");
        return dashboard;

      })
      .catch(reason => {
        console.error(reason);
      })
  }

}


// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/dashboard/dashboard.service.ts